import GlobalUpload from "./upload/index.js";// 上传组件
import GlobalDownload from "./download/index.js";// 下载组件
const components = [
    GlobalUpload,
    GlobalDownload
]

const install = (Vue) => {
    components.forEach(component => {
        Vue.component(component.name, component);
    })
}

if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

export default {
    install,
    GlobalUpload,
    GlobalDownload
}
